export default "__VITE_ASSET___K9DUTz7__"